<template>
    <div
        class="selection-bar"
        data-selected-bar
        style="position: sticky; bottom: 0px"
    >
        <div class="selection-bar__header">
            <div class="container selection-bar__header-content">
                <div class="selection-bar__heading">
                    Wybrano:
                    <span>
                        {{
                            selectedGroups.length
                                | plurals('grupę', 'grupy', 'grup')
                        }}
                    </span>
                    <span>
                        ({{
                            promosCount
                                | plurals('promocję', 'promocje', 'promocji')
                        }})
                    </span>
                </div>

                <div class="selection-bar__actions">
                    <the-btn
                        btn-class="btn-danger"
                        text="Wyczyść zaznaczone"
                        @click.native="unselectAllLabels"
                    ></the-btn>
                    <the-btn
                        btn-class="btn btn-secondary"
                        text="Generuj cenówki"
                        icon="PriceTags"
                        @click.native="downloadLabels"
                    ></the-btn>
                </div>

                <div class="selection-bar__actions-xs">
                    <the-btn
                        btn-class="btn-danger"
                        text="Wyczyść"
                        @click.native="unselectAllLabels"
                    ></the-btn>
                    <the-btn
                        btn-class="btn btn-secondary"
                        text="Generuj"
                        icon="PriceTags"
                        @click.native="downloadLabels"
                    ></the-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        promosCount() {
            return this.selectedGroups.reduce((acc, group) => {
                return acc + group.selectedPromoIds.length
            }, 0)
        },
        selectedGroups() {
            return this.$store.getters.getSelectedLabelGroups
        },
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        typeWord() {
            return this.$options.filters.plurals(
                this.selectedLabelsCount,
                'promocję',
                'promocje',
                'promocji'
            )
        },
        selectedLabelsCount() {
            return this.$store.getters.getSelectedLabelsCount
        },
        selectedLabels() {
            return this.$store.getters.getSelectedLabelGroups
        }
    },
    methods: {
        downloadLabels() {
            if (this.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else {
                this.$store.dispatch('openModal', {
                    component: 'ModalLabels',
                    classes: 'm-labels'
                })
            }
        },
        unselectAllLabels() {
            this.$store.dispatch('unselectAllLabelGroupLabels')
        }
    },
    data() {
        return {
            showPromos: false
        }
    }
}
</script>
<style lang="scss">
.selection-bar {
    position: sticky;
}
.selection-bar__heading {
    &:focus {
        outline: none;
        box-shadow: none;
    }
}
</style>
